import { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { Mail, CheckCircle2 } from 'lucide-react';
import { solicitarRestablecimiento } from '../../lib/auth/passwordReset';

interface ForgotPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ForgotPasswordModal({ isOpen, onClose }: ForgotPasswordModalProps) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  // 🚨 El mensaje de éxito se muestra SIEMPRE, exista la cuenta o no.
  //
  // No es descuido: `tenant-lookup` responde 200 para cualquier correo
  // (contrato §3) precisamente para no revelar quién está registrado, y esta
  // pantalla mantiene esa propiedad. `solicitarRestablecimiento` no lanza;
  // los fallos reales quedan en la consola.
  //
  // Hasta el 2026-09-18 esto era un `setTimeout(1200)` que afirmaba haber
  // enviado sin llamar a nada (issue #76). El texto no cambia — lo que cambia
  // es que ahora es verdad.
  const handleSend = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    await solicitarRestablecimiento(email);
    setLoading(false);
    setSent(true);
  };

  const handleClose = () => {
    setEmail('');
    setSent(false);
    setLoading(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Recuperar contraseña" size="sm">
      {sent ? (
        <div className="forgot-pw__success">
          <div className="forgot-pw__success-icon">
            <CheckCircle2 size={40} style={{ color: '#10B981' }} />
          </div>
          <h3 className="forgot-pw__success-title">¡Instrucciones enviadas!</h3>
          <p className="forgot-pw__success-msg">
            Si el correo <strong>{email}</strong> está registrado en el sistema,
            recibirás un enlace para restablecer tu contraseña en los próximos minutos.
          </p>
          <Button variant="primary" size="sm" onClick={handleClose} style={{ marginTop: '1rem', width: '100%' }}>
            Volver al inicio de sesión
          </Button>
        </div>
      ) : (
        <form onSubmit={handleSend} className="forgot-pw__form">
          <p className="forgot-pw__desc">
            Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.
          </p>
          <Input
            id="forgot-pw-email"
            label="Correo electrónico"
            type="email"
            placeholder="tu@empresa.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            leftIcon={<Mail size={16} />}
            required
          />
          <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.25rem' }}>
            <Button variant="ghost" size="sm" type="button" onClick={handleClose} style={{ flex: 1 }}>
              Cancelar
            </Button>
            <Button variant="primary" size="sm" type="submit" isLoading={loading} style={{ flex: 1 }}>
              Enviar instrucciones
            </Button>
          </div>
        </form>
      )}
    </Modal>
  );
}
